import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { MarkAllNotificationsAsSeenFulfilledAction } from '../../domains/notificationFeeds/actions.types';
import { NotificationLoadMoreFulfilledAction } from '../../domains/notificationPaginations/actions.types';

import { LiveEventsForNotifications } from './types';

export type LiveEventForNotificationAction =
  | MarkAllNotificationsAsSeenFulfilledAction
  | NotificationLoadMoreFulfilledAction;

const initialState: LiveEventsForNotifications = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<LiveEventsForNotifications, LiveEventForNotificationAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MARK_ALL_NOTIFICATIONS_AS_SEEN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.liveEventsForNotification);
    case 'NOTIFICATION.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.liveEventsForNotification);
    default:
      return state;
  }
};

export default reducer;
